/*import {DateTimeString} from "@t/util/CommonTypes.ts";*/

export interface FolderStructure {
	id: string;
	path: string;
	name: string;
	/** Absolute path for embedding the file */
	url: string;
	modified: number;
	/*modified?: DateTimeString;*/
	
	folder?: boolean;
	mimeType?: string;
	size?: number;
	icon?: string;
	preview?: boolean;	
	selected?: boolean;
}

export interface FolderStructureData {
	total: number;
	position: number;
	size: number;
	orderBy?: string;
	desc?: boolean;
	items?: FolderStructure[];
}

export interface Volume {
	id: string;
	path: string;
	title: string;
	type?: number;
	icon: string;
}

export function formatSize(size: number): string  {
	if (!size || size < 0) return "";

	if (size < 1024) return size+" B";

	let kilos = size/1024;
	if (kilos < 1024) return Math.round(kilos)+" kB";

	let megas = kilos/1024.0; //1024.0 - double
	if (megas < 1024) return Math.round(megas)+" MB";

	let gigas = megas/1024.0; //1024.0 - double
	return Math.round(gigas)+" GB";
}

export function formatDate(millis: number): string  {
	const date = new Date(millis);
	return date.toLocaleDateString();	
}

export function formatDateTime(millis: number): string  {
	const date = new Date(millis);
	return date.toLocaleString();	
}
	
/*export function formatDate(dateTimeStr: DateTimeString): string  {
	const date = new Date(dateTimeStr);
	return date.toLocaleDateString();	
}

export function formatDateTime(dateTimeStr: DateTimeString): string  {
	const date = new Date(dateTimeStr);
	return date.toLocaleString();	
}*/